import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';

import NotFound from '../NotFound';
import ShowView from './ShowView';

const FinancialPage = ({ match: { path } }) => (
  <Switch>
    <Route exact path={path} component={ShowView} />
    <Route component={NotFound} />
  </Switch>
);

FinancialPage.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string,
  }),
};

export default FinancialPage;
